import { Application, HealthApiClient } from "@baloise-cfa/tsclient/health";
import { generateApiUrl } from "@lg-cfa/utils";
import { useEffect } from "react";

import { useFlowNavigation } from "../useFlowNavigation";

import { PageNames } from "@enums";

export function useHealth() {
    const isSSR = typeof window === "undefined";
    const { navigateTo } = useFlowNavigation();
    let health = undefined;

    useEffect(() => {
        if (!isSSR) {
            try {
                const client = new HealthApiClient(generateApiUrl("health"));
                Promise.resolve(client.getHealth(Application.LG))
                    .then((r) => {
                        // eslint-disable-next-line react-hooks/exhaustive-deps
                        health = r;
                        if (!health) {
                            navigateTo(PageNames.TechnicalDifficulties);
                        } else if (health) {
                            if (
                                health.fire !== "Healthy" ||
                                health.address !== "Healthy"
                            ) {
                                navigateTo(PageNames.TechnicalDifficulties);
                            }
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        if (
                            (
                                performance?.getEntriesByType(
                                    "navigation",
                                ) as PerformanceNavigationTiming[]
                            )?.[0]?.type &&
                            (
                                performance?.getEntriesByType(
                                    "navigation",
                                ) as PerformanceNavigationTiming[]
                            )?.[0]?.type !== "reload"
                        ) {
                            navigateTo(PageNames.TechnicalDifficulties);
                        }
                    });
            } catch (err) {
                console.error(err);
                navigateTo(PageNames.TechnicalDifficulties);
            }
        }
    }, [isSSR]);

    return health;
}
